import React from 'react';
interface MapInfoItem {
  skuId: number;
  id: number;
  inventoryCount: number;
  inventoryType: string;
  placeOfDispatchId: string;
  storeCode: string;
  quantity: number;
}
interface MapInfo {
  [key: string]: MapInfoItem;
}

export default function InventoryBadge({
  mapInfo,
  item,
}: {
  mapInfo: MapInfo;
  item: SkuTypes.Value;
}) {
  const indexKey = `${item.attrId}:${item.id};`;
  const selected = Object.keys(mapInfo)
    .filter((i) => i.indexOf(indexKey) === 0)
    .map((key) => mapInfo[key]);

  const quantityTotal = selected.reduce((a, { quantity = 0 }) => a + quantity, 0);
  if (quantityTotal > 0) {
    return <span className="badge">x {quantityTotal}</span>;
  }

  return null;
}
